"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.warn = exports.deprecate = exports.resetDeprecationsSeen = void 0;
var deprecationsSeen = {};
var resetDeprecationsSeen = function () {
    deprecationsSeen = {};
};
exports.resetDeprecationsSeen = resetDeprecationsSeen;
var consoleWarn = (typeof console === 'object' && typeof console.warn === 'function')
    ? function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return console.warn.apply(console, args);
    }
    : function () { };
var deprecate = function (msg) {
    if (!deprecationsSeen[msg]) {
        deprecationsSeen[msg] = true;
        consoleWarn("redux-observable | DEPRECATION: " + msg);
    }
};
exports.deprecate = deprecate;
var warn = function (msg) {
    consoleWarn("redux-observable | WARNING: " + msg);
};
exports.warn = warn;



//////////////////
// WEBPACK FOOTER
// ./~/redux-observable/dist/cjs/utils/console.js
// module id = 391
// module chunks = 0